import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LegalNotice = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-slate-800 text-white py-6">
        <div className="max-w-4xl mx-auto px-4">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-[#1F6FD6] hover:text-[#E3EDF9] transition-colors mb-4"
          >
            <ArrowLeft size={20} />
            Retour à l'accueil
          </button>
          <h1 className="text-3xl font-bold">Mentions Légales</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-xl shadow-lg p-8 space-y-8">
          
          {/* Éditeur du site */}
          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-4 border-b-2 border-[#1F6FD6] pb-2">
              1. Éditeur du site
            </h2>
            <div className="space-y-2 text-slate-700">
              <p><strong>Raison sociale :</strong> SMA CONCEPT</p>
              <p><strong>Forme juridique :</strong> EURL (Entreprise Unipersonnelle à Responsabilité Limitée)</p>
              <p><strong>Capital social :</strong> 1 500,00 €</p>
              <p><strong>Siège social :</strong> 2 Rue Sainte Catherine, 42000 Saint-Étienne, France</p>
              <p><strong>SIREN :</strong> 999 676 240</p>
              <p><strong>SIRET :</strong> 999 676 240 00016</p>
              <p><strong>RCS :</strong> Saint-Étienne 999 676 240</p>
              <p><strong>N° TVA intracommunautaire :</strong> FR95999676240</p>
              <p><strong>Activité :</strong> Travaux de menuiserie métallique et serrurerie</p>
              <p><strong>Email :</strong> contact@sma-concept.fr</p>
              <p><strong>Téléphone :</strong> 06 20 60 41 66</p>
              <p><strong>Directeur de la publication :</strong> El Ouazzani Abdel-Ilah, Gérant</p>
            </div>
          </section>

          {/* Hébergeur */}
          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-4 border-b-2 border-[#1F6FD6] pb-2">
              2. Hébergeur du site
            </h2>
            <div className="space-y-2 text-slate-700">
              <p><strong>Hébergeur :</strong> Emergent Technologies</p>
              <p><strong>Site web :</strong> https://emergent.sh</p>
              <p><strong>Services :</strong> Infrastructure cloud et hébergement web</p>
            </div>
          </section>

          {/* Propriété intellectuelle */}
          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-4 border-b-2 border-[#1F6FD6] pb-2">
              3. Propriété intellectuelle
            </h2>
            <div className="space-y-3 text-slate-700">
              <p>
                L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur 
                et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour 
                les documents téléchargeables et les représentations iconographiques et photographiques.
              </p>
              <p>
                La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est 
                formellement interdite sauf autorisation expresse du directeur de la publication.
              </p>
            </div>
          </section>

          {/* Protection des données */}
          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-4 border-b-2 border-[#1F6FD6] pb-2">
              4. Protection des données personnelles (RGPD)
            </h2>
            <div className="space-y-3 text-slate-700">
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi 
                "Informatique et Libertés", vous disposez d'un droit d'accès, de rectification, de 
                suppression et d'opposition aux données personnelles vous concernant.
              </p>
              
              <h3 className="font-bold text-slate-800 mt-4">Collecte des données</h3>
              <p>
                Les données collectées via le formulaire de contact (nom, email, téléphone, message) 
                sont utilisées uniquement pour traiter votre demande de devis et vous recontacter. 
                Ces données ne sont jamais vendues. Elles ne sont transmises qu'à nos sous-traitants techniques (Brevo pour l'email, hébergeur) — voir la politique de confidentialité.
              </p>
              
              <h3 className="font-bold text-slate-800 mt-4">Durée de conservation</h3>
              <p>
                Vos données sont conservées pendant la durée nécessaire au traitement de votre demande, 
                puis archivées conformément aux obligations légales.
              </p>
              
              <h3 className="font-bold text-slate-800 mt-4">Exercer vos droits</h3>
              <p>
                Pour exercer vos droits, contactez-nous à : <strong>contact@sma-concept.fr</strong>
              </p>
            </div>
          </section>

          {/* Cookies */}
          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-4 border-b-2 border-[#1F6FD6] pb-2">
              5. Cookies
            </h2>
            <div className="space-y-3 text-slate-700">
              <p>
                Ce site n'utilise pas de cookies publicitaires ou de traçage. Seuls des cookies 
                techniques essentiels au fonctionnement du site peuvent être utilisés.
              </p>
            </div>
          </section>

          {/* Responsabilité */}
          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-4 border-b-2 border-[#1F6FD6] pb-2">
              6. Limitation de responsabilité
            </h2>
            <div className="space-y-3 text-slate-700">
              <p>
                SMA CONCEPT s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées 
                sur ce site. Toutefois, SMA CONCEPT ne peut garantir l'exactitude, la précision ou 
                l'exhaustivité des informations mises à disposition sur ce site.
              </p>
              <p>
                SMA CONCEPT ne pourra être tenu responsable des dommages directs ou indirects qui pourraient 
                résulter de l'accès au site ou de l'utilisation du site et/ou des informations qui y figurent.
              </p>
            </div>
          </section>

          {/* Liens externes */}
          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-4 border-b-2 border-[#1F6FD6] pb-2">
              7. Liens hypertextes
            </h2>
            <div className="space-y-3 text-slate-700">
              <p>
                Le site peut contenir des liens vers d'autres sites internet. SMA CONCEPT n'exerce aucun 
                contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
              </p>
            </div>
          </section>

          {/* Droit applicable */}
          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-4 border-b-2 border-[#1F6FD6] pb-2">
              8. Droit applicable
            </h2>
            <div className="space-y-3 text-slate-700">
              <p>
                Le présent site et les présentes mentions légales sont soumis au droit français. 
                En cas de litige, les tribunaux français seront seuls compétents.
              </p>
            </div>
          </section>

          {/* Assurance professionnelle */}
          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-4 border-b-2 border-[#1F6FD6] pb-2">
              9. Assurance professionnelle
            </h2>
            <div className="space-y-3 text-slate-700">
              <p>
                En tant qu'entreprise de menuiserie métallique et serrurerie, SMA CONCEPT dispose 
                des assurances professionnelles obligatoires pour l'exercice de son activité.
              </p>
              <div className="bg-[#E3EDF9] p-4 rounded-md border border-[#1F6FD6]">
                <p className="font-semibold mb-2">Assurance décennale et responsabilité civile professionnelle :</p>
                <p><strong>Assureur :</strong> April</p>
                <p><strong>Numéro de contrat :</strong> 26036672144</p>
              </div>
              <p className="text-sm italic">
                Les justificatifs d'assurance sont disponibles sur simple demande à contact@sma-concept.fr
              </p>
            </div>
          </section>

          {/* Date de mise à jour */}
          <section className="pt-6 border-t border-slate-200">
            <p className="text-sm text-slate-500">
              <strong>Dernière mise à jour :</strong> Avril 2026
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default LegalNotice;
